module.exports = __webpack_public_path__ + "static/wallet-passes-854915fb6240c3e2552334c73dc1da70.png";